<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  STC Contact
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <a @click="goBack" >Admin Panel</a>
                    </li>
                    <li class="breadcrumb-item">
                      <router-link to="/escalation/stcform">
                        STC Contact Form</router-link
                      >
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-body">
          <!-- :active="isLoading" -->
          <vue-element-loading  spinner="bar-fade-scale" :active="isLoading" />
          <section>
            <div class="card">
              <div class="card-header px-0 common_top_title_searchbgst_dock">
                <div class="container-fluid">
                  <div class="row row fc_my-05">
                    <div class="w-auto px-1 mobile-padding-0-2">
                      <div
                        class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                      >
                        <div class="avatar-content">
                          <em
                            class="i_icon_st la-chalkboard las lab font-medium-5"
                          ></em>
                        </div>
                      </div>
                      <h4 class="card-title d-inline-flex ml-0 mb-0">
                        STC Contact Form
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container-fluid pt-1 pb-2">
                <div class="row mx-auto">
                  <div class="row mx-0 mt-1">
                    <div class="col-sm-3 mb-1">
                      <label class="form-label text-left w-100">Zone</label>
                      <treeselect
                        placeholder="Select Zone"
                        v-model="formData.zone"
                        :options="zoneList"
                        @input="handleZoneChange"
                      />
                    </div>
                    <div class="col-sm-3 mb-1">
                      <label class="form-label text-left w-100">EDC</label>
                      <treeselect
                        placeholder="Select EDC"
                        v-model="formData.edc"
                        :options="edc_list"
                        @input="handleEdcChange"
                      />
                    </div>
                    <div class="col-sm-3 mb-1">
                      <label class="form-label text-left w-100">STC</label>
                      <treeselect
                        placeholder="Select STC"
                        v-model="formData.stc"
                        :options="stc_list"
                      />
                    </div>
                    <div class="col-sm-3 mb-1">
                      <label class="form-label text-left w-100"
                        >EDC Contact</label
                      >
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Enter EDC Contact"
                        v-model="formData.edc_contact"
                      />
                    </div>
                  </div>

                  <div class="row mx-0 mt-1">
                    <div class="col-sm-3 mb-1">
                      <label class="form-label text-left w-100"
                        >STC Manager</label
                      >
                      <input
                        class="form-control"
                        placeholder="Enter STC Manager"
                        v-model="formData.stc_manager"
                      />
                    </div>
                    <div class="col-sm-3 mb-1">
                      <label class="form-label text-left w-100"
                        >STC Contact</label
                      >
                      <input
                        class="form-control"
                        placeholder="Enter STC Contact"
                        v-model="formData.stc_contact"
                      />
                    </div>
                    <div class="col-sm-3 mb-1">
                      <label class="form-label text-left w-100"
                        >Network Manager</label
                      >
                      <input
                        class="form-control"
                        placeholder="Enter Network Manager"
                        v-model="formData.network_manager"
                      />
                    </div>
                    <div class="col-sm-3 mb-1">
                      <label class="form-label text-left w-100"
                        >Network Contact</label
                      >
                      <input
                        class="form-control"
                        placeholder="Enter Network Contact"
                        v-model="formData.network_contact"
                      />
                    </div>
                    <div class="col-sm-3 mb-1">
                      <label class="form-label text-left w-100">EDC Head</label>
                      <input
                        class="form-control"
                        placeholder="Enter EDC Head"
                        v-model="formData.edc_head"
                      />
                    </div>
                    <div class="col-sm-3 mb-1">
                      <label class="form-label text-left w-100"
                        >EDC Head Contact</label
                      >
                      <input
                        class="form-control"
                        placeholder="Enter EDC Head Contact"
                        v-model="formData.edc_head_contact"
                      />
                    </div>
                  </div>

                   <div
                    class="pull-right text-right col-12 col-sm-12 col-md-12 col-lg-12 px-0"
                  >
                    <button
                      type="button"
                      class="btn btn-relief-primary common-btn_btn_view"
                      style="margin-top: 18px !important"
                      @click="saveData"
                      :disabled="!validateForm()"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue2-datepicker/index.css";
import Treeselect from "@riophae/vue-treeselect";
import VueElementLoading from "vue-element-loading";
import {
  XCircleIcon,
  FileIcon,
  UploadIcon,
  DownloadIcon,
  EditIcon,
} from "vue-feather-icons";
import CONSTANT from "../../constants.js";
import { read, utils } from "xlsx";
import schema from "../../utils/schema.js";
import common_methods from "../../utils/common_methods.js";
import searchMasterNameList from "../../utils/searchMasterNameList.js";

export default {
  name: "escalationStcForm",
  mixins: [common_methods, searchMasterNameList],
  components: {
    Treeselect,
    DatePicker,
    VueTimepicker,
    VueElementLoading,
    Pagination,
    UploadIcon,
    FileIcon,
    XCircleIcon,
    DownloadIcon,
    EditIcon,
    Pagination,
  },
  data() {
    return {
      isLoading: false,
      zoneList: [],
      edc_list: [],
      stc_list: [],
      formData: {
        zone: null,
        edc: null,
        edc_contact: null,
        stc: null,
        stc_manager: null,
        stc_contact: null,
        network_manager: null,
        network_contact: null,
        edc_head: null,
        edc_head_contact: null,
      },
      url:`/search/getdropdowns`
    };
  },
  mounted() {},
  created() {
    this.getZoneLists()
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleZoneChange() {
        this.formData.edc = null;
        this.edc_list = []
      //  console.log(this.formData.zone)
      this.getEDCList()
    },
    handleEdcChange(){
        this.formData.stc =null;
        this.stc_list = [];
       // console.log(this.formData.edc)
        this.getSTCList();
    },
    validateForm() {
      //  console.log(this.formData)
      let isValid = true;
      if (!this.formData.zone) {
        isValid = false;
      }
      if (!this.formData.edc ) {
        isValid = false;
      }
      if(!this.formData.edc_contact)
      {
        isValid = false;
      }
      if (!this.formData.stc) {
        isValid = false;
      } 
      if (!this.formData.stc_manager) {
        isValid = false;
      }
      if (!this.formData.stc_contact) {
        isValid = false;
      }
      if (!this.formData.network_manager) {
        isValid = false;
      }
      if ( !this.formData.network_contact) {
        isValid = false;
      }
      if (!this.formData.edc_head) {
        isValid = false;
      }
      if(!this.formData.edc_head_contact)
      {
        isValid = false;
      }
      return isValid;
    },
    getZoneLists() {
      this.isLoading = true;
    let payload ={
    key:"zone",
    label:"zone",
    table:"ct_ou_master"
    }
      this.makeRequest("POST",this.url,payload)
      .then((result)=>{
        this.isLoading =false;
        this.zoneList = result.data.data.rows
      })
      .catch((e)=>{
        this.displayError(e)
      })
    },
     getEDCList() {
        if(this.formData.zone)
        {
            this.isLoading = true;
    let payload ={
    key:"edc",
    label:"edc",
    table:"ct_ou_master",
    cond_:`AND zone = '${this.formData.zone}'`
    }
      this.makeRequest("POST",this.url,payload)
      .then((result)=>{
        this.isLoading =false;
       // console.log(result.data)
        this.edc_list = result.data.data.rows
      })
      .catch((e)=>{
        this.displayError(e)
      })
        }
    },
    getSTCList() {
        if(this.formData.zone && this.formData.edc)
        {
            this.isLoading = true;
    let payload ={
    key:"ou_code",
    label:"ou_code",
    table:"ct_ou_master",
    cond_:`AND zone = '${this.formData.zone}' AND edc = '${this.formData.edc}'`
    }
      this.makeRequest("POST",this.url,payload)
      .then((result)=>{
        this.isLoading =false;
       // console.log(result.data)
        this.stc_list = result.data.data.rows
      })
      .catch((e)=>{
        this.displayError(e)
      })
        }
    },
    saveData() {
     // console.log(this.formData);
      if (!this.validateForm()) {
        this.sweetAlertSnackbar(
          "Form was invalidated. Make sure that all reuired fields are filled out!",
          "error"
        );
        return;
      }
      try {
        this.isLoading =true;
        let url = `/contacts/stc-create`;
        let payload =this.formData
        this.makeRequest("POST", url, payload)
          .then((result) => {
          //  console.log(result.data);
            this.isLoading =false;
            if (result && result.data && result.data.status) {
               this.sweetAlertSnackbar(result.data.message, "success");
               this.resetFormData()
             } else {
              this.sweetAlertSnackbar(result.data.message, "error");
             }

          })
          .catch((e) => {
            this.displayError(e);
          });
      }catch{
        this.displayError();
      }
    },
    resetFormData(){
       this.formData = {
        zone: null,
        edc: null,
        edc_contact: null,
        stc: null,
        stc_manager: null,
        stc_contact: null,
        network_manager: null,
        network_contact: null,
        edc_head: null,
        edc_head_contact: null,
      }
    }
  },
};
</script>
<style scoped>
.alignment {
  margin-left: 20px;
  margin-bottom: 20px;
}
.requiredField {
  margin-left: 2px;
  color: red;
}
#overlay-camera {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;
  cursor: pointer;
}

.overlay-camera {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;
  cursor: pointer;
}
</style>
